import ionicCoreGlobalScript from '/var/home/fj44404@co.champaign.il.us/.local/code/webmapgl/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
import webmapglGlobalScript from '/var/home/fj44404@co.champaign.il.us/.local/code/webmapgl/src/global/webmapgl.ts';
export const globalScripts = () => {
  webmapglGlobalScript();
  ionicCoreGlobalScript();
};
